<!-- MODAL detalleDocumento -->
<div mdbModal #detalleDocumento="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <form>
    <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Detalle Documento
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="detalleDocumento.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="filtros-body mb-2">
            <div class="row align-items-center" [formGroup]="formFiltro">
              <div class="col-auto">
                <div class="md-form mt-0 mb-0">
                  <input
                    type="text"
                    id="cliente"
                    class="form-control"
                    formControlName="cliente"
                    placeholder=""
                    formatRut
                  />
                  <label for="cliente">Cliente (RUT)</label>
                </div>
              </div>
              <div class="col-auto">
                <button
                  mdbBtn
                  type="button"
                  class="btn-cuadrado"
                  color="secondary"
                  mdbWavesEffect
                  (click)="abrirModalSeleccionarCliente()"
                >
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
              </div>
              <div class="col-auto">
                <span class="text-info">
                  {{ clienteSeleccionado ? clienteSeleccionado.razon_social : 'Ingrese rut del cliente' }}
                </span>
              </div>
              <div class="col-auto" *ngIf="clienteSeleccionado">
                <button mdbBtn type="button" color="light" size="sm" mdbWavesEffect (click)="limpiarClienteSeleccionado()">
                  Limpiar
                </button>
              </div>
              <div class="col-auto">
                <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
                  <mdb-icon fas icon="search"></mdb-icon>
                  Buscar
                </button>
              </div>
            </div>
          </div>
          <div class="table-responsive" *ngIf="listaDocumentos">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Tipo</th>
                  <th scope="col">Folio</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">RUT</th>
                  <th scope="col">Razón Social</th>
                  <th scope="col">Monto</th>
                  <th scope="col" class="text-center">Intento</th>
                  <th scope="col" class="text-center">al SII</th>
                  <th scope="col" class="text-center">Resp SII</th>
                  <th scope="col" class="text-center">Envío Rec</th>
                  <th scope="col" class="text-center">Acuse Rec</th>
                  <th scope="col">Rec.Merc</th>
                  <th scope="col">Resp.Com</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loading">
                  <td colspan="100%" style="text-align: center">
                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                  </td>
                </tr>
                <tr *ngIf="!loading && listaDocumentos?.length === 0">
                  <td colspan="100%" style="text-align: center">
                    No se encontró información
                  </td>
                </tr>
                <tr *ngFor="let doc of listaDocumentos">
                  <td>{{doc.tipoDescripcionAbreviada}}</td>
                  <td>
                    <div class="custom_link c-pointer" (click)="showHistorico(doc)">
                      {{doc.folio | numerico}}
                    </div>

                  </td>
                  <td>{{doc.fecha | fecha}}</td>
                  <td>{{doc.rutFormato | rut}}</td>
                  <td>{{doc.razon_social}}</td>
                  <td>{{doc.monto | numerico}}</td>
                  <td class="text-center">
                    <i *ngIf="doc.id_lsoft" class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center">
                    <i *ngIf="doc.intento_envio_al_sii" class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center">
                    <mdb-badge *ngIf="doc.respuesta_sii === 'ACEPTADO'" pill="true" success="true">{{doc.respuesta_sii}}
                    </mdb-badge>
                    <mdb-badge *ngIf="doc.respuesta_sii === 'REPARO'" pill="true" warning="true">{{doc.respuesta_sii}}
                    </mdb-badge>
                    <mdb-badge *ngIf="doc.respuesta_sii === 'RECHAZADO'" pill="true" danger="true">{{doc.respuesta_sii}}
                    </mdb-badge>
                  </td>
                  <td class="text-center">
                    <i *ngIf="doc.envio_rec" class="fas fa-envelope fa-lg green-text"></i>
                    <ng-container *ngIf="!doc.envio_rec">
                      <i *ngIf="!doc.loading" class="fas fa-paper-plane fa-lg red-text c-pointer"
                        (click)="reSend(doc)"></i>
                      <mdb-spinner *ngIf="doc.loading" spinnerColor="blue" spinnerType="small"></mdb-spinner>
                    </ng-container>
                  </td>
                  <td class="text-center">
                    <i *ngIf="doc.acuse_recibo" class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center">
                    <i *ngIf="doc.recepcion_mercaderia" class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td>
                    <mdb-badge *ngIf="doc.respuesta_comercial === true" pill="true" success="true">Aprobado</mdb-badge>
                    <mdb-badge *ngIf="doc.respuesta_comercial === false" pill="true" danger="true">Rechazado</mdb-badge>
                  </td>
                  <td>
                    <ng-container *ngIf="!doc.loadingPdf">
                      <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                        (click)="downloadDocumentoPDF(doc)" mdbTooltip="Ver" placement="right">
                        <mdb-icon fas icon="eye"></mdb-icon>
                      </button>
                    </ng-container>
                    <ng-container *ngIf="doc.loadingPdf">
                      <mdb-spinner spinnerColor="blue" spinnerType="small"></mdb-spinner>
                    </ng-container>
                  </td>
                </tr>
                <!-- <tr>
                  <td>FE</td>
                  <td>458</td>
                  <td>25/03/2021</td>
                  <td>8156753-0</td>
                  <td>ADELA DEL CARMEN CRUCES ROJO</td>
                  <td>90.800</td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td>
                    <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                  </td>
                  <td class="text-center"><i class="fas fa-envelope" fa-lg></i></td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center"></td>
                  <td>
                    <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                  </td>
                  <td><i class="far fa-file-alt fa-lg"></i></td>
                </tr>
                <tr>
                  <td>FE</td>
                  <td>459</td>
                  <td>25/03/2021</td>
                  <td>8156753-0</td>
                  <td>ADELA DEL CARMEN CRUCES ROJO</td>
                  <td>28.500</td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td>
                    <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                  </td>
                  <td class="text-center"><i class="fas fa-envelope" fa-lg></i></td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center"></td>
                  <td>
                    <mdb-badge pill="true" danger="true">Rechazado</mdb-badge>
                  </td>
                  <td><i class="far fa-file-alt fa-lg"></i></td>
                </tr>
                <tr>
                  <td>FE</td>
                  <td>460</td>
                  <td>25/03/2021</td>
                  <td>9980793-8</td>
                  <td>ADELA DEL TRANSITO ALEGRIA PRADO</td>
                  <td>28.500</td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td>
                    <mdb-badge pill="true" danger="true">Rechazado</mdb-badge>
                  </td>
                  <td class="text-center"><i class="far fa-circle fa-lg"></i></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><i class="far fa-file-alt fa-lg"></i></td>
                </tr>
                <tr>
                  <td>FE</td>
                  <td>461</td>
                  <td>25/03/2021</td>
                  <td>9980793-8</td>
                  <td>ADELA DEL TRANSITO ALEGRIA PRADO</td>
                  <td>90.800</td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td>
                    <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                  </td>
                  <td class="text-center"><i class="fas fa-envelope" fa-lg></i></td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td>
                    <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                  </td>
                  <td><i class="far fa-file-alt fa-lg"></i></td>
                </tr>
                <tr>
                  <td>FE</td>
                  <td>461</td>
                  <td>03/04/2021</td>
                  <td>17920346</td>
                  <td>ADI NAVARRO RIVAS</td>
                  <td>5.700</td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td class="text-center">
                    <i class="fa fa-check-circle fa-lg green-text"></i>
                  </td>
                  <td>
                    <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                  </td>
                  <td class="text-center"><i class="far fa-circle fa-lg"></i></td>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                  <td></td>
                  <td><i class="far fa-file-alt fa-lg"></i></td>
                </tr> -->
              </tbody>
              <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                *ngIf="listaDocumentos?.length > 0"></app-pagination>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="submit" class="btn btn-default waves-light" mdbWavesEffect
            (click)="detalleDocumento.hide()">
            Cerrar
          </button>
          <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcel()">
            Excel
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<app-empresas-emitidos-detalle-historico></app-empresas-emitidos-detalle-historico>

<app-modal-seleccionar-cliente
  [multiple]="false"
  queryType="ONLY_RUT"
  (onSelectSingle)="onClienteSeleccionado($event)"
  (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>
<app-modal-confirm></app-modal-confirm>